export const shenghuoArticles = [
  {
    id: "shenghuo-1",
    title: "网红代餐翻车：营养成分表与实测相差几何",
    summary: "标称的营养数据，与实际检测结果究竟差多少？我们对比了几款热门产品。",
    categoryId: "shenghuo",
    categoryName: "生活真相",
    publishedAt: "2026-10-12 07:40",
    source: "生活检验室",
    tags: ["代餐", "营养成分", "消费提醒"],
    heat: 7120,
    content: [
      "代餐产品因方便快捷受到欢迎，但围绕其营养数据的讨论也一直存在。为厘清差异，我们比对了几款热门产品的标称值与公开检测结果。",
      "## 标称与实测的差距",
      "对比显示，部分产品在蛋白质与膳食纤维的标称值上较为准确，但也有产品的实际值低于标签标注。",
      "营养专业人士提醒，代餐不能完全替代正餐，长期依赖可能导致营养不均衡。",
      "## 看标签也要看成分",
      "消费者在选购时，除了关注热量，还应留意蛋白质与微量元素的实际含量，避免被营销话术带偏。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "shenghuo-2",
    title: "预制菜进校园争议：标准缺失下的信任危机",
    summary: "预制菜进入校园供餐的话题引发家长担忧。争议的核心，其实是标准与透明。",
    categoryId: "shenghuo",
    categoryName: "生活真相",
    publishedAt: "2026-10-11 12:30",
    source: "食安观察",
    tags: ["预制菜", "校园供餐", "标准"],
    heat: 7480,
    content: [
      "预制菜在餐饮和零售场景中越来越常见，但当它进入校园供餐的讨论中，家长的反应明显更为谨慎。",
      "## 家长究竟担心什么",
      "受访家长表示，他们的担忧集中在食材来源、添加剂使用以及营养是否均衡等方面，而目前可获得的信息并不充分。",
      "业内人士指出，预制菜本身品类繁多，不能一概而论，关键在于是否有统一且可执行的标准。",
      "## 透明是最好的沟通",
      "多方建议，供餐信息应向家长公开，包括食材来源与加工方式，以透明换信任。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "shenghuo-3",
    title: "美容院预付卡跑路频发，监管新规能否堵住漏洞",
    summary: "充值越多优惠越大，可门店一旦关门，卡里的钱就悬了。新规带来了哪些变化？",
    categoryId: "shenghuo",
    categoryName: "生活真相",
    publishedAt: "2026-10-10 16:00",
    source: "消费维权台",
    tags: ["预付卡", "美容", "监管"],
    heat: 6340,
    content: [
      "预付式消费在美容、美发等行业十分普遍。优惠力度越大，消费者一次性充值金额往往越高，风险也随之上升。",
      "## 跑路的共同特征",
      "梳理多起案例可以发现，门店在关闭前常有明显的征兆，例如频繁更换店招、低价促销、以及员工工资出现拖欠。",
      "针对这些问题，多地已出台预付资金监管的新规，要求一定规模的经营者进行资金存管。",
      "## 新规落地需要时间",
      "消费者代表提醒，新规效果取决于执行力度，建议充值金额不宜过大，并保留好凭证。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "shenghuo-4",
    title: "健身房闭店潮背后：预付资金池的监管盲区",
    summary: "办卡容易退卡难。健身行业的预付模式为何频频出问题？我们做了梳理。",
    categoryId: "shenghuo",
    categoryName: "生活真相",
    publishedAt: "2026-10-09 10:15",
    source: "体育消费观察",
    tags: ["健身房", "预付资金", "闭店"],
    heat: 5890,
    content: [
      "近年来，健身行业经历了一轮扩张与收缩。部分门店在快速开店后突然闭店，让众多会员措手不及。",
      "## 预付资金池的风险",
      "从业者介绍，健身房的现金流高度依赖预付卡销售，一旦新增会员放缓，资金链条就容易紧绷。",
      "由于预付资金缺乏统一存管，一旦经营不善，会员往往难以优先拿回余额。",
      "## 理性办卡与制度保障并行",
      "专家建议，消费者应优先选择短期卡种，同时行业也应推进资金存管，降低系统性风险。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "shenghuo-5",
    title: "宠物殡葬乱象：高价套餐背后的灰色地带",
    summary: "情感寄托遇上信息不对称，宠物殡葬的价格与服务成为新的关注点。",
    categoryId: "shenghuo",
    categoryName: "生活真相",
    publishedAt: "2026-10-08 13:20",
    source: "城市生活报",
    tags: ["宠物殡葬", "价格", "服务"],
    heat: 4960,
    content: [
      "随着养宠家庭增多，宠物殡葬服务需求上升。但这一相对新兴的领域，价格与服务标准仍不够透明。",
      "## 价格为何差异巨大",
      "调查显示，同类服务在不同机构之间的报价相差可达数倍，套餐内容也缺乏统一说明。",
      "有从业者坦言，行业门槛较低，部分机构在服务过程中存在信息不透明的情况。",
      "## 让告别更有尊严",
      "受访者希望，行业能尽快建立起基本的服务规范与价格公示，让这份情感寄托得到应有的尊重。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
  {
    id: "shenghuo-6",
    title: "网红餐厅排队几小时值不值：探店内容与真实体验的差距",
    summary: "镜头里的精致摆盘，到了桌上可能判若两人。探店内容与真实体验差的究竟是什么？",
    categoryId: "shenghuo",
    categoryName: "生活真相",
    publishedAt: "2026-10-07 19:55",
    source: "食味评测组",
    tags: ["探店", "餐饮", "内容真实"],
    heat: 4630,
    content: [
      "在社交平台的推动下，一批网红餐厅迅速走红。然而，不少慕名而来的消费者发现，实际体验与视频内容存在差距。",
      "## 镜头与餐桌的距离",
      "对比可发现，探店内容往往会使用特定角度与光线突出菜品，而出餐品质在不同时段也可能波动较大。",
      "有餐饮从业者表示，旺季客流激增时，出品稳定性确实会受到影响。",
      "## 理性看待种草内容",
      "消费者协会提示，探店内容仅供参考，建议结合多方评价后再做选择，避免盲目跟风。",
      "本文为演示示例内容，人物、机构与数据均为虚构，仅用于展示页面排版与交互效果。",
    ],
  },
];